import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    amount: 'Amount credited',
    amountDescription:
      'This amount matches the amount credited to your account after deductions of interbank fees and exchange fees applied by intermediary banks.',
    initialAmount: 'Initial amount',
    initialAmountDescription:
      'This amount matches the amount entered by the sender.',
  },
  fr: {
    amount: 'Montant crédité',
    amountDescription:
      'Ce montant correspond à la somme créditée sur votre compte après déductions des frais interbancaires et frais de change appliqués par les banques intermédiaires.',
    initialAmount: 'Montant initial',
    initialAmountDescription:
      'Ce montant correspond au montant saisi par l’émetteur du virement.',
  },
} as const);

export default locales;
